import React, { useState, useEffect, useCallback } from 'react';
import './NotificationPopup.css';

const NotificationPopup = ({ title, body, url, onClose, onOpenVideo }) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleClose = useCallback(() => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 300); // Wait for animation to complete
  }, [onClose]);

  useEffect(() => {
    // Show popup with animation
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    // Auto-hide after 5 seconds
    const autoHideTimer = setTimeout(() => {
      handleClose();
    }, 5000);

    return () => {
      clearTimeout(timer);
      clearTimeout(autoHideTimer);
    };
  }, [handleClose]);

  const handleClick = () => {
    if (url) {
      onOpenVideo(url);
    }
    handleClose();
  };

  return (
    <div className={`notification-popup ${isVisible ? 'visible' : ''}`}>
      <div className="notification-content" onClick={handleClick}>
        <div className="notification-header">
          <div className="notification-icon">🔔</div>
          <button className="notification-close" onClick={(e) => {
            e.stopPropagation();
            handleClose();
          }}>
            ×
          </button>
        </div>
        <div className="notification-body">
          <h4 className="notification-title">{title}</h4>
          <p className="notification-text">{body}</p>
          {url && (
            <div className="notification-action">
              <span className="action-text">Tap to watch video</span>
              <span className="action-arrow">→</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationPopup;
